// Balkan Bug corporate network — the sister sites ShowMeTrade cross-promotes (and that
// cross-promote ShowMeTrade back). Single registry used by the footer, the partner rotation
// (see partners.ts) and the analytics CORS allowlist. Keep this the only place these URLs live.
//
// Cross-links are editorial links between sites of the same group (not paid placements), so
// they are plain followed links; UTM is added for attribution only.

export interface NetworkSite {
  host: string;
  name: string;
  url: string;
  tagline: { sr: string; en: string };
  /** where the site sits in the group's funnel — used for copy/placement decisions */
  role: 'education' | 'prop' | 'prediction' | 'founder';
}

export const NETWORK_SITES: NetworkSite[] = [
  {
    host: 'fxdoctor.pro',
    name: 'FXDoctor',
    url: 'https://fxdoctor.pro',
    tagline: { sr: 'edukacija za trejdere, kursevi i Master 1 na 1', en: 'trading education, courses and 1-on-1 mentoring' },
    role: 'education',
  },
  {
    host: 'dayprop.net',
    name: 'DayProp.net',
    url: 'https://dayprop.net',
    tagline: { sr: 'prop nalog do 25.000 $ bez testa (Nivo 1)', en: 'funded account up to $25,000, no evaluation (Level 1)' },
    role: 'prop',
  },
  {
    host: 'dayprop.com',
    name: 'DayProp.com',
    url: 'https://dayprop.com',
    tagline: { sr: 'forex i kripto prop nalozi (Nivo 2)', en: 'forex and crypto funded accounts (Level 2)' },
    role: 'prop',
  },
  {
    host: 'swissprimemarkets.com',
    name: 'Swiss Prime Markets',
    url: 'https://swissprimemarkets.com',
    tagline: { sr: 'fjučers prop trejding na CME (Nivo 3)', en: 'CME futures prop trading (Level 3)' },
    role: 'prop',
  },
  {
    host: 'predvidi.me',
    name: 'Predvidi.me',
    url: 'https://predvidi.me',
    tagline: { sr: 'tržišta predviđanja na srpskom', en: 'prediction markets in Serbian' },
    role: 'prediction',
  },
  {
    host: 'nikolabroceta.com',
    name: 'Nikola Broćeta',
    url: 'https://nikolabroceta.com',
    tagline: { sr: 'osnivač, tržišta od 2003', en: 'founder, markets since 2003' },
    role: 'founder',
  },
];

/** Outbound URL with attribution (utm_source=showmetrade, medium = placement). */
export function networkHref(site: NetworkSite, medium: 'footer' | 'banner' | 'profile' | 'forum'): string {
  const u = new URL(site.url);
  u.searchParams.set('utm_source', 'showmetrade');
  u.searchParams.set('utm_medium', medium);
  u.searchParams.set('utm_campaign', 'network');
  return u.toString();
}

/** Origins allowed to POST beacons to /api/track (ad creatives embedded on partner sites). */
export const NETWORK_ORIGINS: string[] = NETWORK_SITES.flatMap((s) => [`https://${s.host}`, `https://www.${s.host}`]);
